import { useTranslation } from 'react-i18next';

import CustomSelectField, {
  CustomSelectFieldProps,
} from 'components/forms/customSelectField/CustomSelectField';
import { orderBy } from 'utils/arrayUtils';
import { TIMEZONES } from 'utils/constants/timezones';
import {
  getTimezoneDescriptiveName,
  getTimezoneOffset,
  getTimezoneOffsetName,
} from 'utils/timezones';
import { formatOptionLabelWithHighlight } from '../multiSelectField/formatOptionLabel';

export interface TimezoneSelectFieldProps
  extends Omit<CustomSelectFieldProps, 'options'> {}

const TimezoneSelectField = ({ ...props }: TimezoneSelectFieldProps) => {
  const {
    i18n: { language },
    t,
  } = useTranslation();

  const timezoneObjects = Object.values(TIMEZONES).map(
    ({ timezone, locationIdentifier }) => {
      return {
        descriptiveName: getTimezoneDescriptiveName({ language, timezone }),
        locationIdentifier: t(locationIdentifier),
        offset: getTimezoneOffset({ timezone }).offset,
        timezone,
        timezoneOffsetName: getTimezoneOffsetName({ language, timezone }),
      };
    },
  );

  const options = orderBy(timezoneObjects, [
    { field: 'offset', order: 'asc' },
    { field: 'descriptiveName', order: 'asc' },
    { field: 'locationIdentifier', order: 'asc' },
  ]).map((timezoneObject) => {
    return {
      label: `${timezoneObject.timezoneOffsetName} - ${timezoneObject.descriptiveName} - ${timezoneObject.locationIdentifier}`,
      value: timezoneObject.timezone,
    };
  });
  return (
    <CustomSelectField
      formatOptionLabel={formatOptionLabelWithHighlight}
      options={options}
      {...props}
    />
  );
};

export default TimezoneSelectField;
